/* global jQuery */

import GA4Tracking from './utils/ga4-tracking'

export const addViewCartOnPageLoad = () => {
  const gaViewItemElement = jQuery('[data-ga-vc]')
  if (gaViewItemElement.length === 0) {
    return
  }

  let gaItems = gaViewItemElement.attr('data-ga-vc')
  gaItems = JSON.parse(gaItems)
  if (typeof gaItems !== 'object') {
    return
  }

  GA4Tracking.pushEvent('view_cart', gaItems)
}
